module.exports = __webpack_public_path__ + "img/avatar-73.9d720d9e.png";